module.exports = __webpack_public_path__ + "static/media/Bluestar.e164c917.webp";